import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enHome from './locales/en/home.json';
import enAudit from './locales/en/audit.json';
import enSegmentation from './locales/en/segmentation.json';
import enBrandSafety from './locales/en/brandSafety.json';
import enBrandSuitability from './locales/en/brandSuitability.json';
import enAboutUs from './locales/en/aboutUs.json';
import enContact from './locales/en/contact.json';
import enNavBar from './locales/en/navBar.json';
import enFooter from './locales/en/footer.json';
import enPrivacy from './locales/en/privacyPolicy.json';
import enExitModal from './locales/en/exitModal.json';

import ptHome from './locales/pt/home.json';
import ptAudit from './locales/pt/audit.json';
import ptSegmentation from './locales/pt/segmentation.json';
import ptBrandSafety from './locales/pt/brandSafety.json';
import ptBrandSuitability from './locales/pt/brandSuitability.json';
import ptAboutUs from './locales/pt/aboutUs.json';
import ptContact from './locales/pt/contact.json';
import ptNavBar from './locales/pt/navBar.json';
import ptFooter from './locales/pt/footer.json';
import ptPrivacy from './locales/pt/privacyPolicy.json';
import ptExitModal from './locales/pt/exitModal.json';

const resources = {
  en: {
    home: enHome,
    audit: enAudit,
    segmentation: enSegmentation,
    brandSafety: enBrandSafety,
    brandSuitability: enBrandSuitability,
    aboutUs: enAboutUs,
    contact: enContact,
    navBar: enNavBar,
    footer: enFooter,
    privacy: enPrivacy,
    exitModal: enExitModal,
  },
  pt: {
    home: ptHome,
    audit: ptAudit,
    segmentation: ptSegmentation,
    brandSafety: ptBrandSafety,
    brandSuitability: ptBrandSuitability,
    aboutUs: ptAboutUs,
    contact: ptContact,
    navBar: ptNavBar,
    footer: ptFooter,
    privacy: ptPrivacy,
    exitModal: ptExitModal,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    detection: {
      order: ['navigator', 'localStorage', 'cookie'],
      caches: ['localStorage', 'cookie'],
    },
  });

export default i18n;
